<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" fullscreen persistent>
      <v-card height="100%">
        <v-form ref="form" v-model="valid" lazy-validation class="scroll-form">
          <v-card-title
            class="headline indigo darken-4 white--text fixed-header"
            primary-title
          >
            {{ $vuetify.t('$vuetify.calls.workAssessment').toUpperCase() }}
          </v-card-title>
          <v-card-text>
            <v-radio-group v-model="siteOcccupied" :rules="radioRules" required>
              <div slot="label">
                {{ $vuetify.t('$vuetify.workAssessment.isTheSiteOccupied') }}
              </div>
              <v-radio
                :label="$vuetify.t('$vuetify.app.yes')"
                value="1"
              ></v-radio>
              <v-radio
                :label="$vuetify.t('$vuetify.app.no')"
                value="0"
              ></v-radio>
            </v-radio-group>
          </v-card-text>
          <v-card-text class="blue-grey lighten-5">
            <v-radio-group
              v-model="asbestosRegister"
              :rules="radioRules"
              required
            >
              <div slot="label">
                {{
                  $vuetify.t(
                    '$vuetify.workAssessment.haveYouCheckedSiteAsbestosRegister'
                  )
                }}
              </div>
              <v-radio
                :label="$vuetify.t('$vuetify.app.yes')"
                value="1"
              ></v-radio>
              <v-radio
                :label="$vuetify.t('$vuetify.app.no')"
                value="0"
              ></v-radio>
            </v-radio-group>
          </v-card-text>
          <v-card-text v-if="asbestosRegister == 0">
            <v-radio-group
              v-model="asbestosResponsiblePerson"
              :rules="radioRules"
              required
              class="ml-3"
            >
              <div slot="label">
                {{
                  $vuetify.t(
                    '$vuetify.workAssessment.haveYouCheckedAbestosWithResponsiblePerson'
                  )
                }}
              </div>
              <v-radio
                :label="$vuetify.t('$vuetify.app.yes')"
                value="1"
              ></v-radio>
              <v-radio
                :label="$vuetify.t('$vuetify.app.no')"
                value="0"
              ></v-radio>
            </v-radio-group>
          </v-card-text>
          <v-card-text
            class="blue-grey lighten-5"
            v-if="asbestosResponsiblePerson == 0"
          >
            <v-radio-group
              v-model="chanceOfAsbestos"
              :rules="radioRules"
              required
              class="ml-5"
              @change="checkAbortingVisit()"
            >
              <div slot="label">
                {{
                  $vuetify.t(
                    '$vuetify.workAssessment.chanceOfDisturbingAsbestos'
                  )
                }}
              </div>
              <v-radio
                :label="$vuetify.t('$vuetify.app.yes')"
                value="1"
              ></v-radio>
              <v-radio
                :label="$vuetify.t('$vuetify.app.no')"
                value="0"
              ></v-radio>
            </v-radio-group>
          </v-card-text>
          <v-card-text>
            <v-radio-group v-model="lonePolicy" :rules="radioRules" required>
              <div slot="label">
                {{
                  $vuetify.t('$vuetify.workAssessment.isLonePolicyApplicable')
                }}
              </div>
              <v-radio
                :label="$vuetify.t('$vuetify.app.yes')"
                value="1"
              ></v-radio>
              <v-radio
                :label="$vuetify.t('$vuetify.app.no')"
                value="0"
              ></v-radio>
            </v-radio-group>
          </v-card-text>
          <div class="footer text-xs-center mb-3">
            <v-divider></v-divider>
            <v-btn @click="back()">
              {{ $vuetify.t('$vuetify.calls.back') }}
            </v-btn>
            <v-btn color="success" :disabled="!valid" @click="goToNext()">
              {{ $vuetify.t('$vuetify.calls.proceedToTheNextSection') }}
            </v-btn>
            <abort-visit v-on:aborted="visitAborted()" />
          </div>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="escalationDialog" fullscreen persistent>
      <v-card>
        <v-card-title
          class="headline indigo darken-4 white--text"
          primary-title
        >
          {{
            $vuetify
              .t('$vuetify.workAssessment.escalationProcess')
              .toUpperCase()
          }}
        </v-card-title>

        <v-card-text>
          {{ $vuetify.t('$vuetify.workAssessment.contactYourController') }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-layout row justify-center>
            <v-btn
              color="success"
              class="mr-3"
              @click="escalationDialog = false"
            >
              {{ $vuetify.t('$vuetify.app.back') }}
            </v-btn>

            <abort-visit is-button="1" v-on:aborted="visitAborted()" />
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <powra-a
      :show="powraADialog"
      v-on:confirmed="powraAConfirmed(...arguments)"
      :call="callDetail"
      v-on:aborted="visitAborted(callDetail.id)"
      v-on:back=";(dialog = true), (powraADialog = false)"
    />
    <powra-b
      :show="powraBDialog"
      v-on:confirmed="powraBConfirmed(...arguments)"
      v-on:aborted="visitAborted(callDetail.id)"
      v-on:back=";(powraADialog = true), (powraBDialog = false)"
    />
    <powra-c
      :show="powraCDialog"
      v-on:confirmed="powraCConfirmed(...arguments)"
      v-on:aborted="visitAborted(callDetail.id)"
      v-on:back=";(powraBDialog = true), (powraCDialog = false)"
    />
    <powra-e
      :show="powraEDialog"
      :hazards="hazards"
      :controls="controls"
      v-on:confirmed="powraEConfirmed(...arguments)"
      v-on:aborted="visitAborted(callDetail.id)"
      v-on:back=";(powraCDialog = true), (powraEDialog = false)"
    />
    <powra-g
      :show="powraGDialog"
      :hazards="hazards"
      :controls="controls"
      v-on:confirmed="powraGConfirmed(...arguments)"
      v-on:aborted="visitAborted(callDetail.id)"
      v-on:back=";(powraEDialog = true), (powraGDialog = false)"
    />
    <powra-h
      :show="powraHDialog"
      v-on:confirmed="powraHConfirmed(...arguments)"
      :call="callDetail"
      v-on:aborted="visitAborted(callDetail.id)"
      v-on:back=";(powraGDialog = true), (powraHDialog = false)"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import AbortVisit from '@/components/AbortVisit.vue'
import PowraA from '@/components/powra/PowraA.vue'
import PowraB from '@/components/powra/PowraB.vue'
import PowraC from '@/components/powra/PowraC.vue'
import PowraE from '@/components/powra/PowraE.vue'
import PowraG from '@/components/powra/PowraG.vue'
import PowraH from '@/components/powra/PowraH.vue'
import moment from 'moment'
import _ from 'underscore'
import powraData from '../../data/forms/powra.json'

import '../../assets/styles/powra.scss'

export default {
  props: ['show', 'method'],
  components: {
    AbortVisit,
    PowraA,
    PowraB,
    PowraC,
    PowraE,
    PowraG,
    PowraH
  },
  data() {
    return {
      dialog: false,
      valid: false,
      siteOcccupied: null,
      powra: 1,
      asbestosRegister: null,
      asbestosResponsiblePerson: null,
      chanceOfAsbestos: null,
      lonePolicy: null,
      radioRules: [v => !!v || 'This field is required'],
      escalationDialog: false,
      escalation_at: null,
      powraADialog: false,
      powraBDialog: false,
      powraCDialog: false,
      powraEDialog: false,
      powraGDialog: false,
      powraHDialog: false,
      powraProcessColumns: {
        call_assignment_id: null,
        task_details: null,
        workarea_access: null,
        hazards: null,
        controls: null,
        hazards_controls: null,
        name: null,
        position: null,
        signature_path: null,
        signoff_signature: null
      },
      hazards: [],
      controls: [],
      powraFAdequateControlsToHazards: false,
      powraData
    }
  },
  computed: {
    ...mapGetters({
      getActiveCall: 'calls/getActiveCall',
      hasPowra: 'calls/hasPowra',
      getHazards: 'calls/getHazards',
      getControls: 'calls/getControls'
    }),
    callDetail() {
      return this.getActiveCall
    }
  },
  methods: {
    ...mapActions({
      powraProcess: 'calls/powraProcess',
      newPowraVersion: 'calls/newPowraVersion',
      saveRiskAssessmentHazardsControls:
        'calls/saveRiskAssessmentHazardsControls'
    }),
    goToNext() {
      if (this.$refs.form.validate()) {
        this.checkAbortingVisit()
        if (!this.escalationDialog) {
          this.dialog = false
          this.powraADialog = true
        }
      }
    },
    checkAbortingVisit() {
      if (this.chanceOfAsbestos == 1) {
        this.escalationDialog = true
        this.escalation_at = moment().format('YYYY-MM-DD hh:mm:ss')
      }
    },
    confirmWorkAssessment() {
      if (this.$refs.form.validate()) {
        if (this.powra == 0) {
          this.powraADialog = true
        } else {
          this.dialog = false
          this.$emit('confirmed', {
            site_occupied: this.siteOcccupied,
            powra_completed: this.powra,
            asbestos_register_signed: this.asbestosRegister,
            asbestos_checkin_completed: this.asbestosResponsiblePerson,
            asbestos_present: this.chanceOfAsbestos,
            lone_working_policy: this.lonePolicy,
            work_assessment_escalation_at: this.escalation_at
          })
        }
      }
    },
    powraAConfirmed(payload) {
      this.powraADialog = false
      this.powraBDialog = true
      this.powraProcessColumns.task_details = payload.task_details
    },
    powraBConfirmed(payload) {
      this.powraBDialog = false
      this.powraCDialog = true
      this.powraProcessColumns.workarea_access = _.pick(payload, function(
        value
      ) {
        return value
      })
    },
    powraCConfirmed(payload) {
      this.powraCDialog = false
      this.powraEDialog = true

      this.powraProcessColumns.hazards = _.pick({ ...payload }, function(
        value
      ) {
        return value
      })
      this.hazards = this.getHazards
    },
    powraEConfirmed(payload) {
      this.powraEDialog = false

      if (Object.keys(this.hazards).length > 0) {
        this.powraGDialog = true
      } else {
        this.powraHDialog = true
      }

      this.controls = payload.controls

      if (payload.powraFAdequateControlsToHazards == true) {
        payload.controls.length = 20
      }

      this.powraFAdequateControlsToHazards =
        payload.powraFAdequateControlsToHazards

      this.powraProcessColumns.controls = _.pick(
        { ...payload.controls },
        function(value) {
          return value
        }
      )
    },
    powraGConfirmed(payload) {
      this.powraGDialog = false
      this.powraHDialog = true
      this.powraProcessColumns.hazards_controls = _.pick(
        { ...payload },
        function(value) {
          return value
        }
      )
      this.saveRiskAssessmentHazardsControls(
        this.powraProcessColumns.hazards_controls
      )
    },
    powraHConfirmed(payload) {
      this.powraHDialog = false
      this.powra = '1'
      this.powraProcessColumns.call_assignment_id = this.callDetail.call_assignment_id
      this.powraProcessColumns.name = payload.name
      this.powraProcessColumns.position = payload.position
      this.powraProcessColumns.signoff_signature = payload.signoff_signature

      const powraParams = _.pick(
        this.powraProcessColumns,
        'call_assignment_id',
        'task_details',
        'name',
        'position',
        'signoff_signature'
      )
      powraParams.fields = {
        workarea_access: this.powraProcessColumns.workarea_access,
        hazards: this.powraProcessColumns.hazards,
        controls: this.powraProcessColumns.controls,
        hazards_controls: this.powraProcessColumns.hazards_controls
      }

      if (!this.hasPowra) {
        this.powraProcess(powraParams)
        this.confirmWorkAssessment()
      } else {
        this.newPowraVersion(powraParams)
        this.$emit('close')
      }
    },
    visitAborted() {
      this.dialog = false
      this.$emit('aborted')
    },
    back() {
      this.dialog = false
      this.$emit('back')
    }
  },
  watch: {
    show: function(newVal, oldVal) {
      this.dialog = newVal
    },
    '$store.state.calls.currentRiskAssessment.fields.controls': function() {
      this.controls = this.$store.state.calls.currentRiskAssessment.fields.controls
    },
    '$store.state.calls.currentRiskAssessment.fields.hazards': function() {
      this.hazards = this.$store.state.calls.currentRiskAssessment.fields.hazards
    }
  }
}
</script>

<style scoped lang="scss">
.footer {
  position: -webkit-sticky;
  position: sticky;
  background-color: #ffffff;
  bottom: 0;
  width: 100%;
  height: 100px;
}

.fixed-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 300;
}

.scroll-form {
  height: 100%;
  position: relative;
  overflow-y: scroll;
}
</style>
